/*
 * DD AdminUI
 * Copyright (C) Fraunhofer IESE 2019 - 2025 Stefan Schweitzer, Shyalan Ramesh, Rafael Aranda López King,
 * Florian Wege, Johannes Schneider, Kazi Rezoanur Rahman, Christoph Müller, Pedram Jokar,
 * Mher Ter-Tovmasyan, Ben Burkhard, Matthias Gerbershagen, Anna Kleiner, Muhammad Tariq,
 * Adeline Silva Schäfer
 *
 * SPDX-License-Identifier: Apache-2.0
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import create, { GetState, SetState } from 'zustand';
import { devtools } from 'zustand/middleware';
import createTreeListSlice, { TreeListSlice } from './slices/treeList.slice';
import createFilterSlice, { FilterSlice } from './slices/filter.slice';
import createGeoAreaTreeSlice, { GeoAreaTreeSlice } from './slices/geoAreaTree.slice';

export interface Store extends GeoAreaTreeSlice, FilterSlice, TreeListSlice {}

const useStore = create<Store>(
	devtools(
		(set, get) => ({
			...createGeoAreaTreeSlice(set as unknown as SetState<GeoAreaTreeSlice>, get as unknown as GetState<Store>),
			...createFilterSlice(set as unknown as SetState<FilterSlice>),
			...createTreeListSlice(set as unknown as SetState<TreeListSlice>, get as unknown as GetState<Store>)
		}),
		{ name: 'config-ui' }
	)
);

export { useStore };
